let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) subscribers[eventName] = [];
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');
  return (msie > 0 || trident > 0);
}

function publish(eventName, data) {
  if (subscribers[eventName]) subscribers[eventName].forEach((callback) => callback(data));
}

function createObserver(options) {
  const threshold = options.threshold ? options.threshold : 0;
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, { rootMargin: `0px 0px ${threshold}px 0px` });
  observer.observe(options.element);
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function convertBreakpoint(breakpoint) {
  let screen;
  switch (breakpoint) {
    case 'small':
      screen = '(max-width: 749px)';
      break;
    case 'medium':
      screen = '(min-width: 750px) and (max-width: 1024px)';
      break;
    case 'large-up':
      screen = '(min-width: 1025px)';
      break;
  }

  return screen
}

function setScrollbarWidth() {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  if (scrollbarWidth > 0) document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
}

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

function closeSideDrawer() {
  const sideDrawers = document.querySelectorAll('side-drawer, cart-drawer, pickup-availability-drawer');
  [...sideDrawers].forEach(drawer => drawer.close());
}

function closeActiveSideDrawer() {
  const activeSideDrawers = document.querySelectorAll('.drawer.active');
  [...activeSideDrawers].forEach(drawer => drawer.close());
}

function hideModalDialog() {
  const modalDialogs = document.querySelectorAll('modal-dialog, quick-add-modal');
  [...modalDialogs].forEach(modal => modal.hide());
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling.getAttribute('id')) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  summary.addEventListener('click', (event) => event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open')));
  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = () => document.removeEventListener('keydown', trapFocusHandlers.keydown);

  trapFocusHandlers.keydown = function (event) {
    // If not TAB key
    if (event.code.toUpperCase() !== 'TAB') return;
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
  const opts = Object.defineProperty({}, 'passive', {
    get: () => {
      ThemeSupportsPassive = true;
    }
  });
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
  });

  window.addEventListener('mousedown', (event) => mouseClick = true);

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}

function visibleMedia(media) {
  return Array.from(media).find((item) => {
    const style = window.getComputedStyle(item);
    return style.display !== 'none';
  });
}

function pauseAllMedia() {
  // Pause YouTube videos
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  // Request the paused state for Vimeo videos
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"getPaused"}', '*');
  });

  // Add a single event listener for the message event
  window.addEventListener('message', (event) => {
    // Ensure the message is from YouTube
    if (event.origin.includes('youtube.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
          const playerState = data.info.playerState;
          const video = event.source.frameElement; // Get the iframe that sent the message

          // If the video is playing (playerState = 1), pause it
          if (playerState === 1) {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            video.classList.add('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing YouTube response:', error);
      }
    }

    // Ensure the message is from Vimeo
    if (event.origin.includes('vimeo.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.method === 'getPaused') {
          const video = event.source.frameElement; // Get the iframe that sent the message
          if (video && !data.value) { // If the video is playing
            video.contentWindow.postMessage('{"method":"pause"}', '*');
            video.classList.add('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing Vimeo response:', error);
      }
    }
  });

  // Pause all HTML5 video elements (native <video> elements)
  document.querySelectorAll('video').forEach((video) => {
    if (!video.paused && !video.ended) {
      video.pause();
      video.classList.add('paused');
    }
  });

  // Pause 3D models (model-viewer)
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI && model.modelViewerUI.isPaused) {
      model.modelViewerUI.play(); // Assuming modelViewerUI has a play method
      model.classList.add('paused'); // Add 'paused' class to indicate it's paused
    }
  });
}

function playAllPausedMedia() {
  // Play YouTube videos that have the 'paused' class
  document.querySelectorAll('.js-youtube.paused').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    video.classList.remove('paused'); // Remove 'paused' class after playing
  });

  // Request the paused state for Vimeo videos and play if paused (using 'paused' class)
  document.querySelectorAll('.js-vimeo.paused').forEach((video) => {
    video.contentWindow.postMessage('{"method":"getPaused"}', '*');
  });

  // Listen for message events (for Vimeo and YouTube)
  window.addEventListener('message', (event) => {
    if (event.origin.includes('youtube.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
          const playerState = data.info.playerState;
          const video = event.source.frameElement; // Get the iframe that sent the message
          if (playerState === 2) { // playerState 2 means paused
            video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            video.classList.remove('paused'); // Optionally remove the paused class
          }
        }
      } catch (error) {
        console.error('Error parsing YouTube response:', error);
      }
    }

    if (event.origin.includes('vimeo.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.method === 'getPaused') {
          const video = event.source.frameElement;
          if (video && data.value) { // If video is paused (data.value is true)
            video.contentWindow.postMessage('{"method":"play"}', '*');
            video.classList.remove('paused'); // Optionally remove the paused class
          }
        }
      } catch (error) {
        console.error("Error parsing Vimeo response:", error);
      }
    }
  });

  // Play HTML5 video elements that have the 'paused' class
  document.querySelectorAll('video.paused').forEach((video) => {
    video.play();
    video.classList.remove('paused'); // Remove 'paused' class after playing
  });

  // Play 3D models (model-viewer) if they are paused and have the 'paused' class
  document.querySelectorAll('product-model.paused').forEach((model) => {
    if (model.modelViewerUI && model.modelViewerUI.isPaused) {
      model.modelViewerUI.play(); // Assuming modelViewerUI has a play method
      model.classList.remove('paused'); // Remove 'paused' class after playing
    }
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) return;
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.shopMoney.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) return 0;
    number = number.toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class CardHoverDistance extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver(() => this.update());
  }

  get breakpoint() {
    return this.dataset.breakpoint || null
  }

  get parent() {
    return this.closest(this.dataset.parent)
  }

  connectedCallback() {
    this.init();
    this.resizeObserver.observe(document.body);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  init() {
    if (!this.parent || !this.breakpoint) return;
    this.update();
    this.resizeObserver.observe(document.body);
  }

  update() {
    if (!this.parent) return;
    const matches = window.matchMedia(convertBreakpoint(this.breakpoint)).matches;
    if (matches) {
      this.parent.style.setProperty('--card-hover-distance', `${this.offsetHeight}px`);
    } else {
      this.parent.style.removeProperty('--card-hover-distance');
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.init();
    }
  }
}

customElements.define('card-hover-distance', CardHoverDistance);

class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 400
    });
  }

  get breakpoint() {
    return this.dataset.breakpoint
  }

  get details() {
    return this.querySelector('details')
  }

  get summary() {
    return this.querySelector('summary')
  }

  init() {
    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.toggle.bind(this));
    this.checkBreakpoint();
    window.addEventListener('resize', this.checkBreakpoint.bind(this));
  }

  checkBreakpoint() {
    if (this.breakpoint == 'all' || this.breakpoint == undefined) return;
    if (!window.matchMedia(convertBreakpoint(this.breakpoint)).matches) {
      this.details.setAttribute('open', true);
    } else if (this.dataset.open == undefined) {
      this.details.removeAttribute('open');
    }
  }

  toggle(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    this.details.removeAttribute('open');
  }
}

customElements.define('collapsible-content', CollapsibleContent);

class DeclarativeShadowElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (!(template instanceof HTMLTemplateElement)) return;
      const shadow = this.attachShadow({ mode: 'open' });
      shadow.append(template.content.cloneNode(true));
    }
  }
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.onPosterClick = this.onPosterClick.bind(this);
    this.togglePlayPause = this.togglePlayPause.bind(this);
    this.toggleSound = this.toggleSound.bind(this);
  }

  connectedCallback() {
    this.posterElement?.addEventListener('click', this.onPosterClick);
    this.controlElement?.addEventListener('click', this.togglePlayPause);
    this.soundElement?.addEventListener('click', this.toggleSound);

    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  disconnectedCallback() {
    this.posterElement?.removeEventListener('click', this.onPosterClick);
    this.controlElement?.removeEventListener('click', this.togglePlayPause);
    this.soundElement?.removeEventListener('click', this.toggleSound);
  }

  static get observedAttributes() {
    return ['playing', 'muted']
  }

  get autoplay() {
    return this.hasAttribute('autoplay')
  }

  get playing() {
    return this.hasAttribute('playing')
  }

  get muted() {
    return this.hasAttribute('muted')
  }

  get posterElement() {
    return this.querySelector('[id^="Deferred-Poster-"]')
  }

  get controlElement() {
    return this.querySelector('.media__control-button')
  }

  get soundElement() {
    return this.querySelector('.media__sound-button')
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null
  }

  get player() {
    return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this.playerHandler(target, prop);
        };
      }
    });
  }

  init() {
    if (this.autoplay) if (!this.paused) this.play();
  }

  onPosterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
  }

  togglePlayPause(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
    button.classList.toggle('is-pause', this.paused);
    button.classList.toggle('is-play', !this.paused);
  }

  toggleSound(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    if (this.muted) {
      this.soundOn();
    } else {
      this.soundOff();
    }
    button.classList.toggle('is-unmuted', this.muted);
    button.classList.toggle('is-muted', !this.muted);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
        this.paused = false;
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
        this.paused = true;
      }
      this.updateControlButton();
    }
    if (name === 'muted') {
      if (oldValue === null && newValue === '') {
        this.dispatchEvent(new CustomEvent('video:muted', { bubbles: true }));
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent('video:unmuted', { bubbles: true }));
      }
      this.updateSoundButton();
    }
  }

  play() {
    if (!this.playing) this.player.play();
  }

  pause() {
    if (this.playing) this.player.pause();
  }

  soundOff() {
    if (!this.muted) this.player.muted();
  }

  soundOn() {
    if (this.muted) this.player.unmuted();
  }

  updateControlButton() {
    const button = this.controlElement;
    button?.classList.toggle('is-pause', this.paused);
    button?.classList.toggle('is-play', !this.paused);
  }

  updateSoundButton() {
    const button = this.soundElement;
    button?.classList.toggle('is-unmuted', this.muted);
    button?.classList.toggle('is-muted', !this.muted);
  }
}

class ImageAnimation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('loaded', true);
  }
}

customElements.define('image-animation', ImageAnimation);

class ImageZoom extends HTMLElement {
  constructor() {
    super();

    this.image = this.querySelector('img');
    this.addEventListener('mousemove', this.onZoom.bind(this));
    this.addEventListener('mouseover', this.onZoom.bind(this));
    this.addEventListener('mouseleave', this.offZoom.bind(this));
  }

  onZoom(event) {
    const x = event.clientX - event.target.offsetLeft;
    const y = event.clientY - event.target.offsetTop;
    this.image.style.transformOrigin = `${x}px ${y}px`;
    this.image.style.transform = "scale(2)";
  }

  offZoom() {
    this.image.style.transformOrigin = `center center`;
    this.image.style.transform = "scale(1)";
  }
}

customElements.define('image-zoom', ImageZoom);

class FocalPoint extends HTMLElement {
  constructor() {
    super();
    if (!this.button) return;
    this.button.addEventListener('click', this.onClickButton.bind(this));
  }

  get button() {
    return this.querySelector('button')
  }

  get popup() {
    return document.querySelector(this.dataset.popup)
  }

  onClickButton(event) {
    if (!this.popup) return;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.popup.show();
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('modal-show', 'overflow-hidden');
  }

  onBodyClick(event) {
    if (!this.popup) return;
    if (!this.button.contains(event.target) && !this.popup.contains(event.target)) {
      this.popup.hide();
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('modal-show', 'overflow-hidden');
    }
  }
}

customElements.define('focal-point', FocalPoint);

class FocalPopup extends HTMLElement {
  constructor() {
    super();
    const resizeObserver = new ResizeObserver(() => this.setPosition());
    resizeObserver.observe(document.body);
    document.body.addEventListener('click', this.onBodyEvent.bind(this));
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    // console.log('this.container', this.container)
    this.container.appendChild(this);
    this.load();
  }

  get point() {
    return document.querySelector(this.dataset.point)
  }

  get container() {
    return this.closest('[data-focal-container]')
  }

  load() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.appendChild(content.firstElementChild);
      this.setAttribute('loaded', true);
    }
  }

  show(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.setAttribute('open', '');
    this.setPosition();
  }

  hide() {
    this.removeAttribute('open');
  }

  setPosition() {
    if (this.hasAttribute('open')) {
      console.log("===", this.point)
      console.log("===", this.container)
      let positionTop = this.point.getBoundingClientRect().top - this.container.getBoundingClientRect().top;
      let positionLeft = this.point.getBoundingClientRect().left - this.container.getBoundingClientRect().left;
      this.style.setProperty(`--top`, `${positionTop}px`);
      this.style.setProperty(`--left`, `${positionLeft}px`);
      // let checkTop = positionTop + this.offsetHeight + this.point.offsetHeight/2 + 8 > this.container.offsetHeight;
      let checkLeft = positionLeft + this.offsetWidth + this.point.offsetWidth / 2 + 8 > this.container.offsetWidth;
      this.classList.toggle('position-right', checkLeft);
      // this.classList.toggle('position-bottom', checkTop);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onBodyEvent(event) {
    if ((!this.contains(event.target)) && (!this.point.contains(event.target))) this.hide();
  }
}

customElements.define('focal-popup', FocalPopup);

class LoadingOverlay extends HTMLElement {
  constructor() {
    super();
  }

  enableLoading() {
    this.classList.remove('hidden');
    this.querySelector('[aria-hidden]')?.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.classList.add('hidden');
    this.querySelector('[aria-hidden]')?.setAttribute('aria-hidden', true);
  }
}

customElements.define('loading-overlay', LoadingOverlay);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.delay = 0;
    this.animate = false;
    this.bindEvents();
  }

  get button() {
    return this.querySelector('[id^="ModalClose-"]');
  }

  get overlay() {
    return this.querySelector('[id^="Modal-Overlay-"]');
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    const modalId = this.getAttribute('id');
    const duplicate = Array.from(document.body.children).find(
      (element) => element !== this && element.id === modalId
    );

    if (duplicate) {
      // Keep modal-dialog source of truth. If duplicate is not a modal-dialog,
      // remove it and keep current modal instance.
      if (duplicate.tagName && duplicate.tagName.toLowerCase() === 'modal-dialog') {
        this.remove();
        return;
      }
      duplicate.remove();
    }

    document.body.appendChild(this);
    this.messageBox = this.querySelector('.form__message');
    this.checked = false;
    if (!this.messageBox) return;
    // Check & Open modal if errors or success message exist
    if (this.messageBox.classList.contains('form__message--error') || this.messageBox.classList.contains('form__message--success')) this.checked = true;
    this.checked === true && this.show();
  }

  bindEvents() {
    this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.hide());
    this.overlay?.addEventListener('click', this.hide.bind(this, false));
    this.button?.addEventListener('click', this.hide.bind(this, false));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      const template = this.querySelector('.template-popup');
      if (!template) return;
      content.appendChild(template.content.firstElementChild.cloneNode(true));
      template.parentNode.appendChild(content.firstElementChild);
      this.setAttribute('loaded', true);
    }
  }

  show(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const templatePopup = this.querySelector('.template-popup');
    if (templatePopup) this.loadContent();
    setTimeout(() => {
      this.setAttribute('open', '');
      this.classList.add('animate', 'active');
      this.querySelector('.modal__content').scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setScrollbarWidth();
      document.body.classList.add('modal-show', 'overflow-hidden');
    }, this.delay);
    document.body.dispatchEvent(new CustomEvent('modalOpened'));
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    publish('modal-opener', {
      data: {
        element: triggeredBy
      },
    });
        
  }

  hide() {
    this.removeAttribute('open');
    this.classList.remove('animate', 'active');
    document.body.classList.remove('modal-show', 'overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    removeTrapFocus(this.activeElement);
    window.playAllPausedMedia();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalDialogColor extends HTMLElement {
  constructor() {
    super();
    this.delay = 0;
    this.animate = false;
    this.bindEvents();
  }

  get button() {
    return this.querySelector('[id^="ModalClose-"]');
  }

  get overlay() {
    return this.querySelector('[id^="Modal-Overlay-"]');
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.elements = Array.from(document.body.children).filter(element => element.id == this.getAttribute('id'));
    this.elements.length > 0 ? this.remove() : document.body.appendChild(this);
    this.setPosition();
    this.handleResize = debounce(this.setPosition.bind(this), 300);
    window.addEventListener('resize', this.handleResize);
  }

  setPosition() {
    const idPopup = this.id;
    const element = document.querySelector(`[data-modal="#${idPopup}"]`);

    if (element) {
      const rect = element.getBoundingClientRect();
      // console.log(rect.top, rect.left, rect.width, rect.height);

      const popupHeight = 450;
      const viewportHeight = window.innerHeight;

      let top = rect.top - 90;
      let left = rect.left + 20;
      let topIcon = rect.top;
      let leftIcon = rect.left + 21;

      if (top + popupHeight > viewportHeight) {
        top = Math.max(viewportHeight - popupHeight - 20, 20);
      }

      this.style.setProperty('--position-top', `${top}px`);
      this.style.setProperty('--position-left', `${left}px`);
      this.style.setProperty('--position-top-icon', `${topIcon}px`);
      this.style.setProperty('--position-left-icon', `${leftIcon}px`);
    }
  }

  bindEvents() {
    this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.hide());
    this.overlay?.addEventListener('click', this.hide.bind(this, false));
    this.button?.addEventListener('click', this.hide.bind(this, false));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      const template = this.querySelector('.template-popup');
      if (!template) return;
      content.appendChild(template.content.firstElementChild.cloneNode(true));
      template.parentNode.appendChild(content.firstElementChild);
      this.setAttribute('loaded', true);
    }
  }

  show(triggeredBy) {
    this.setPosition();
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const templatePopup = this.querySelector('.template-popup');
    if (templatePopup) this.loadContent();
    setTimeout(() => {
      this.setAttribute('open', '');
      this.classList.add('animate', 'active');
      this.querySelector('.modal__content').scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setScrollbarWidth();
      document.body.classList.add('modal-show', 'overflow-hidden');
    }, this.delay);
    document.body.dispatchEvent(new CustomEvent('modalOpened'));
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    publish('modal-opener', {
          data: {
            element: triggeredBy
          },
        });
  }

  hide() {
    this.removeAttribute('open');
    this.classList.remove('animate', 'active');
    document.body.classList.remove('modal-show', 'overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    removeTrapFocus(this.activeElement);
    window.playAllPausedMedia();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('modal-dialog-color', ModalDialogColor);


class ModalOpenerColor extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', (event) => {

      event.preventDefault();
      event.stopPropagation();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener-color', ModalOpenerColor);


class MoreLessLayout extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".more-less-layout__content");
    this.button = this.querySelector("button");
    this.readMoreText = this.getAttribute("data-read-more-text") || "Read More";
    this.readLessText = this.getAttribute("data-read-less-text") || "Read Less";
    this.maxLinesDesktop = parseInt(this.getAttribute("data-max-lines-desktop"), 10) || 3;
    this.maxLinesMobile = parseInt(this.getAttribute("data-max-lines-mobile"), 10) || 2;
    this.expanded = false;
    this.updateStyles();
    this.checkButtonVisibility();
    this.button.addEventListener("click", () => this.toggleReadMore());
  }

  updateStyles() {
    this.content.style.display = "-webkit-box";
    this.content.style.overflow = "hidden";
    this.content.style.webkitBoxOrient = "vertical";
    this.content.style.webkitLineClamp = this.getMaxLines();
  }

  getMaxLines() {
    return window.matchMedia('(min-width: 1025px)').matches ? this.maxLinesDesktop : this.maxLinesMobile
  }

  toggleReadMore() {
    if (this.expanded) {
      this.content.style.webkitLineClamp = this.getMaxLines();
      this.button.querySelector('span:not(.icon)').textContent = this.readMoreText;
    } else {
      this.content.style.webkitLineClamp = "unset";
      this.button.querySelector('span:not(.icon)').textContent = this.readLessText;
    }
    this.classList.toggle('expanded', !this.expanded);
    this.expanded = !this.expanded;
  }

  checkButtonVisibility() {
    const fullLines = this.getFullLineCount();
    const maxLines = this.getMaxLines();
    this.button.closest('.more-less-layout__button').classList.toggle('hidden', fullLines <= maxLines);
  }

  getFullLineCount() {
    const style = window.getComputedStyle(this.content);
    const lineHeight = parseFloat(style.lineHeight);
    const fullHeight = this.content.scrollHeight;
    return Math.round(fullHeight / lineHeight);
  }

  connectedCallback() {
    window.addEventListener('resize', () => {
      if (!this.expanded) {
        this.updateStyles();
        this.checkButtonVisibility();
      }
    });
  }
}

customElements.define('more-less-layout', MoreLessLayout);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class SideDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  get overlay() {
    return this.querySelector('[id^="Drawer-Overlay-"]');
  }

  connectedCallback() {
    this.bindEvents();
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  bindEvents() {
    this.overlay.addEventListener('click', this.close.bind(this));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (this.activeElement) this.activeElement.setAttribute('open', '');
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      setScrollbarWidth();
    }, { once: true });
    document.body.classList.add('drawer-show');
  }

  close() {
    this.classList.remove('animate', 'active');
    if (this.activeElement) this.activeElement.removeAttribute('open');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('drawer-show');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('side-drawer', SideDrawer);

class SideDrawerOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    let _target = event.currentTarget;
    const drawer = document.querySelector(this.getAttribute('data-side-drawer'));
    drawer && (_target.hasAttribute('open') ? drawer.close() : drawer.open(_target));
  }
}

customElements.define('side-drawer-opener', SideDrawerOpener);

class ThemeSwiper extends HTMLElement {
  constructor() {
    super();
    this.disable = false;
    this._onVideoEnded = null;
    this.slider = this.querySelector('.swiper');
    this.pagination = this.querySelector(`.swiper-pagination[id="Pagination-Slider-${this.dataset.sliderId}"]`) || this.querySelector('.swiper-pagination');
    this.scrollbar = this.querySelector('.swiper-scrollbar');
    this.prev = this.querySelector(`.swiper-navigation[id="Navigation-Slider-${this.dataset.sliderId}"] .swiper-button-prev`) || this.querySelector('.swiper-button-prev');
    this.next = this.querySelector(`.swiper-navigation[id="Navigation-Slider-${this.dataset.sliderId}"] .swiper-button-next`) || this.querySelector('.swiper-button-next');
    this.play = this.querySelector('.swiper-button-play');
    this.pause = this.querySelector('.swiper-button-pause');
    // this.count = this.querySelector('[data-swiper-count]');
    this.breakpointList = ['small', 'medium', 'large-up'];
    this.defaultSettings = this.dataset.swiper || {};
    if (Object.keys(this.defaultSettings).length != 0) this.defaultOptions = JSON.parse(this.defaultSettings);
    this.options = Object.assign({}, this.defaultOptions);
    this.options = {
      ...this.options,
      pagination: {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}">${index + 1}</span>`;
        }
      },
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          const selectedElement = element.slides[element.activeIndex];
          if (selectedElement && selectedElement.dataset.type === 'video') this.handleVideoIn(selectedElement, element);
          this.setActiveSlideItemInit(element);
          this.checkNavigation(element);
          this.checkPagination(element);
          this.updatePagination(element);
          // Set data index attr
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
        }
      }
    }
  }

  get autoplayDelayTime() {
    return parseInt(this.getAttribute('data-autoplay-delay'))
  }

  get items() {
    return this._items = this._items || Array.from(this.querySelectorAll('.swiper-slide'));
  }

  get markedItem() {
    return this._markedItem = this._markedItem || this.querySelector('.swiper-slide.swiper-slide-active [data-marked]');
  }

  connectedCallback() {
    if (!this.getAttribute('loaded')) {
      createObserver({
        element: this,
        callback: this.init.bind(this),
        threshold: -200
      });
    } else {
      this.init();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.scrollElement = newValue ? this.querySelector(newValue) : null;
      this.swiper?.update();
    }
  }

  init() {
    if (!this.disable) {
      this.disable = true;
      this.lastOutIndex = null;
      this.options.touchStartPreventDefault = false;
      this.options.touchStartForcePreventDefault = false;
      this.swiper = new Swiper(this.slider, this.options);
      this.setSlideHeight();
      this.lastOutIndex = this.swiper.activeIndex;

      this.swiper.on('resize', () => {
        // code here
        this.checkNavigation(this.swiper);
        this.checkPagination(this.swiper);
        this.setSlideHeight();
      });

      this.swiper.on('update', () => {
        // code here
        this.checkNavigation(this.swiper);
        this.checkPagination(this.swiper);
        this.setSlideHeight();
      });

      // this.swiper.on('beforeSlideChangeStart', () => {
      //   if (this.swiper.previousIndex === this.swiper.activeIndex) {
      //     this.swiper.slides.forEach((element) => {
      //       if (element.dataset.type === 'video') this.handleVideoOut(element, this.swiper);
      //     });
      //   }
      // });

      this.swiper.on('transitionStart', () => {
        let oldElement;
        if (this.swiper.previousIndex !== this.swiper.activeIndex) {
          oldElement = this.swiper.slides[this.swiper.previousIndex];
        } else {
          oldElement = this.swiper.slides[this.lastOutIndex];
        }

        if (oldElement && oldElement.dataset.type === 'video') this.handleVideoOut(oldElement, this.swiper);
        this.swiper.mousewheel.enabled = false;
        this.lastOutIndex = this.swiper.previousIndex;
      });

      this.swiper.on('transitionEnd', () => {
        let newElement = this.swiper.slides[this.swiper.activeIndex];
        if (newElement && newElement.dataset.type === 'video') this.handleVideoIn(newElement, this.swiper);
        this.swiper.mousewheel.enabled = true;
        this.lastOutIndex = this.swiper.activeIndex;
      });

      // this.swiper.on('touchStart', () => {
      //   if (this.swiper.params.autoplay.enabled && this.swiper.autoplay.running) {
      //     this.swiper.autoplay.stop();
      //     this.classList.add('theme-swiper--paused');
      //     this.play?.classList.remove('hidden');
      //     this.pause?.classList.add('hidden');
      //   }
      // });

      this.swiper.on('slideChange', () => {
        this.swiper.pagination.render();
        this.swiper.pagination.update();
        this.swiper.navigation.destroy();
        this.swiper.navigation.init();
        this.dispatchEvent(new CustomEvent('slider:change', { bubbles: true, detail: { currentPage: this.swiper.activeIndex } }));
      });

      this.swiper.on('paginationUpdate', () => {
        this.updatePagination(this.swiper);
      });

      this.swiper.on('slideChangeTransitionStart', () => {
        // code here
      });

      this.swiper.on('slideChangeTransitionEnd', () => {
        // code here
      });

      this.play?.addEventListener('click', this.playSlider.bind(this));
      this.pause?.addEventListener('click', this.pauseSlider.bind(this));

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => this.setActiveSlideItem(this.items.indexOf(event.target)));
      }
    } else if (this.disable) {
      if (this.swiper) {
        this.swiper.destroy();
        this.disable = false;
      }
    }
  }

  setActiveSlideItem(activeIndex) {
    this.swiper && this.swiper.slideTo(activeIndex);
  }

  setActiveSlideItemInit(swiper) {
    const indexInit = this.dataset.activeIndexInit;
    indexInit && swiper.slideTo(indexInit);
  }

  unSlider(swiper) {
    if (swiper) {
      swiper.destroy();
      this.disable = false;
    }
  }

  setSlideHeight() {
    if (!this.markedItem) return;
    this.style.setProperty('--slide-height', `${this.markedItem.offsetHeight}px`);
  }

  handleVideoOut(oldElement, swiper) {
    if (!oldElement) return;
    const videoElement = window.visibleMedia(oldElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    videoElement.pause();
    if (this._onVideoEnded) {
      videoElement.removeEventListener('video:ended', this._onVideoEnded);
      this._onVideoEnded = null;
    }
  }

  handleVideoIn(newElement, swiper) {
    if (!newElement) return;
    const videoElement = window.visibleMedia(newElement.querySelectorAll('video-media'));
    if (!videoElement) return;
    if (swiper.params.autoplay.enabled && swiper.autoplay.running) swiper.autoplay.stop();
    videoElement.play();
    const handleVideoEnd = () => {
      this._onVideoEnded = null;
      videoElement.removeEventListener('video:ended', handleVideoEnd);
      if (swiper.params.autoplay.enabled) swiper.autoplay.start();
    };
    this._onVideoEnded = handleVideoEnd;
    videoElement.addEventListener('video:ended', this._onVideoEnded);
  }

  playSlider() {
    this.play?.classList.add('hidden');
    this.pause?.classList.remove('hidden');
    this.swiper.params.autoplay.delay = this.autoplayDelayTime;
    this.swiper.autoplay.start();
    this.classList.remove('theme-swiper--paused');
  }

  pauseSlider() {
    this.pause?.classList.add('hidden');
    this.play?.classList.remove('hidden');
    this.swiper.params.autoplay.delay = 0;
    this.swiper.autoplay.stop();
    this.classList.add('theme-swiper--paused');
  }

  updatePagination(swiper) {
    if (!swiper) return;
    const cloneSlides = swiper.el.querySelectorAll('.swiper-slide--cloned');
    if (cloneSlides.length === 0) return;
    const bullets = swiper.pagination.bullets;
    if (bullets.length <= 1) return;
    const index = swiper.realIndex - 1;
    const halfLength = Math.floor(bullets.length / 2);
    if (index >= halfLength - 1) {
      for (let i = 0; i < halfLength; i++) {
        bullets[i].style.display = 'none';
      }
    } else {
      for (let i = halfLength; i < bullets.length; i++) {
        bullets[i].style.display = 'none';
      }
    }
  }

  checkPagination(swiper) {
    let pagination = swiper.pagination;
    if (!pagination.el || pagination.bullets.length == 1) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-pagination', !pagination.el.classList.contains(`${breakpoint}-hide`));
  }

  checkNavigation(swiper) {
    let navigation = swiper.navigation;
    if (!navigation?.nextEl && !navigation?.prevEl) return;
    const nextDisabled = navigation.nextEl?.hasAttribute('disabled');
    const prevDisabled = navigation.prevEl?.hasAttribute('disabled');
    if (nextDisabled && prevDisabled) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-navigation', !navigation.nextEl.closest('.swiper-navigation').classList.contains(`${breakpoint}-hide`));
  }
}

customElements.define('theme-swiper', ThemeSwiper);

class ThemeTab extends HTMLElement {
  constructor() {
    super();
  }

  get allItems() {
    return this._allItems = this._allItems || this.querySelectorAll('[data-filter]')
  }

  filtering(value) {
    if (value == 'all') {
      Array.from(this.allItems).forEach((item) => item.classList.remove('hidden'));
    } else {
      const items = this.querySelectorAll(`[data-filter=${value}]`);
      Array.from(this.allItems).forEach((item) => item.classList.add('hidden'));
      Array.from(items).forEach((item, index) => {
        item.classList.remove('hidden')
        if (index == 0) item.querySelector('button')?.click();
      });
    }
  }

  open(button, tab) {
    if (button) this.setActiveElement(button);
    const _targetTab = button.closest('li');
    if (_targetTab.classList.contains('active')) return;
    const _currentTab = this.querySelector(`li.active`);
    const _currentTabContent = this.querySelector(`.tab__content-item.active`);
    const _targetTabContent = this.querySelector(`[data-tab-id="${tab}"]`);
    this.load(_targetTabContent);
    _currentTab.classList.remove('active');
    _currentTabContent.classList.remove('active');
    _targetTab.classList.add('active');
    _targetTabContent.classList.add('active');
  }

  load(tab) {
    if (!tab.getAttribute('loaded')) {
      const content = tab.querySelector('template').content.cloneNode(true);
      tab.appendChild(content);
      tab.setAttribute('loaded', true);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('theme-tab', ThemeTab);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    closeActiveSideDrawer();

    trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), this.detailsContainer.querySelector('input:not([type="hidden"])'));
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this._open = this.details.hasAttribute('open');
    this.onSummaryClick = this.onSummaryClick.bind(this);
  }

  get open() {
    return this._open
  }

  set open(value) {
    value = Boolean(value);
    if (value !== this._open) {
      this._open = value;
      if (value) {
        this.details.setAttribute('open', '');
      } else {
        this.details.removeAttribute('open');
      }

      if (this.isConnected) {
        this.transition(value);
      }
    }

    this.details.setAttribute('aria-expanded', value ? 'true' : 'false');
    this.dispatchEvent(new CustomEvent('toggle', { bubbles: true, detail: { current: this } }));
  }

  get details() {
    return this._details || this.querySelector('details')
  }

  get summaryElement() {
    return this._summaryElement || this.querySelector('summary')
  }

  get contentElement() {
    return this._contentElement || this.querySelector('summary + *')
  }

  get state() {
    return this.details.hasAttribute('open')
  }

  connectedCallback() {
    this.summaryElement?.addEventListener('click', this.onSummaryClick);
  }

  disconnectedCallback() {
    this.summaryElement?.removeEventListener('click', this.onSummaryClick);
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.toggle();
  }

  toggle(forceState = !this.open) {
    this.open = forceState;
  }

  async transition(isOpening) {
    const startHeight = this.details.offsetHeight;
    const endHeight = isOpening ? this.summaryElement.offsetHeight + this.contentElement.scrollHeight : this.summaryElement.offsetHeight;
    this.details.style.overflow = 'hidden';
    this.details.style.height = `${startHeight}px`;
    if (isOpening) {
      this.details.setAttribute('open', '');
      this.contentElement.style.opacity = 0;
      this.contentElement.style.transform = 'translateY(10px)';
    }

    const animation = this.details.animate([
      { height: `${startHeight}px`, offset: 0 },
      { height: `${endHeight}px`, offset: 1 }
    ], {
      duration: 300,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'both'
    });

    const contentAnimation = this.contentElement.animate(
      isOpening
        ? [
          { opacity: 0, transform: 'translateY(10px)', offset: 0 },
          { opacity: 1, transform: 'translateY(0)', offset: 1 }
        ]
        : [
          { opacity: 1, transform: 'translateY(0)', offset: 0 },
          { opacity: 0, transform: 'translateY(10px)', offset: 1 }
        ],
      {
        duration: 200,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        fill: 'both',
        delay: isOpening ? 100 : 0
      }
    );

    await Promise.all([animation.finished, contentAnimation.finished]);

    if (!isOpening) {
      this.details.removeAttribute('open');
    }

    this.details.style.height = 'auto';
    this.details.style.overflow = 'visible';
    this.contentElement.style.opacity = '';
    this.contentElement.style.transform = '';
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class DetailsDisclosures extends HTMLElement {
  constructor() {
    super();
    this._onToggle = this._onToggle.bind(this);
  }

  connectedCallback() {
    if (!this.onlyOne) return;
    this.enforceSingleOpen();
    this.observeDetails();
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
    if (this.observer) this.observer.disconnect();
  }

  get onlyOne() {
    return this.hasAttribute('only-one');
  }

  get allDetailsDisclosure() {
    return this._allDetailsDisclosure = Array.from(this.querySelectorAll('details-disclosure'));
  }

  addEventListeners() {
    this.allDetailsDisclosure.forEach(detailsDisclosure => detailsDisclosure.addEventListener('toggle', this._onToggle));
  }

  removeEventListeners() {
    if (!this._allDetailsDisclosure) return;
    this._allDetailsDisclosure.forEach(detailsDisclosure => detailsDisclosure.removeEventListener('toggle', this._onToggle));
  }

  _onToggle(event) {
    const current = event.currentTarget;
    if (!current.open || !this.onlyOne) return;
    this.allDetailsDisclosure.forEach(detailsDisclosure => {
      if (detailsDisclosure !== current) {
        requestAnimationFrame(() => detailsDisclosure.toggle(false));
      }
    });
  }

  enforceSingleOpen() {
    let firstOpenFound = false;
    this.allDetailsDisclosure.forEach(detailsDisclosure => {
      if (detailsDisclosure.open) {
        if (!firstOpenFound) {
          firstOpenFound = true;
        } else {
          detailsDisclosure.toggle(false);
        }
      }
    });
  }

  observeDetails() {
    this.observer = new MutationObserver(() => {
      this.removeEventListeners();
      this._allDetailsDisclosure = null;
      this.enforceSingleOpen();
      this.addEventListeners();
    });

    this.observer.observe(this, { childList: true, subtree: true });
  }
}

customElements.define('details-disclosures', DetailsDisclosures);

class ResizeNotifier extends ResizeObserver {
  #initialized = false;

  constructor(callback) {
    super((entries) => {
      if (this.#initialized) return callback(entries, this);
      this.#initialized = true;
    });
  }

  disconnect() {
    this.#initialized = false;
    super.disconnect();
  }
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => this.onChange(event), ON_CHANGE_DEBOUNCE_TIMER).bind(this));
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

class OverflowList extends HTMLElement {
  constructor() {
    super();

    this._reflowFrameId = null;
    this.lastDimensions = { width: null, height: null };
    this.handleChange = this.handleChange.bind(this);
    this.reflowItems = this.reflowItems.bind(this);
    this.resizeObserver = new ResizeObserver(this.handleChange);
    this.mutationObserver = new MutationObserver(this.handleChange);
    this.refs = {};
  }

  static get observedAttributes() {
    return ['disabled', 'minimum-items'];
  }

  get minimumItems() {
    const value = this.getAttribute('minimum-items');
    return value ? parseInt(value, 10) : null;
  }

  get defaultSlot() {
    return this.refs?.defaultSlot;
  }

  get overflowSlot() {
    return this.refs?.overflowSlot;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'disabled') {
      newValue === 'true' ? this.reset() : this.requestReflow();
    }
  }

  connectedCallback() {
    if (!this.shadowRoot) this.initializeShadowRoot();
    this.collectShadowRefs();
    this.addEventListener('reflow', (event) => this.requestReflow(event.detail?.lastVisibleElement));
    this.requestReflow();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    if (this._reflowFrameId !== null) {
      cancelAnimationFrame(this._reflowFrameId);
      this._reflowFrameId = null;
    }
  }

  initializeShadowRoot() {
    const template = this.querySelector(':scope > template');
    if (!(template instanceof HTMLTemplateElement)) return;
    const shadow = this.attachShadow({ mode: 'open' });
    shadow.append(template.content.cloneNode(true));
    template.remove();
  }

  collectShadowRefs(){
    const shadowRoot = this.shadowRoot;
    if (!shadowRoot) throw new Error('Missing shadow root');
    const defaultSlot = shadowRoot.querySelector('slot:not([name])');
    const overflowSlot = shadowRoot.querySelector('slot[name="overflow"]');
    const moreSlot = shadowRoot.querySelector('slot[name="more"]');
    const overflow = shadowRoot.querySelector('[part="overflow"]');
    const list = shadowRoot.querySelector('[part="list"]');
    const placeholder = shadowRoot.querySelector('[part="placeholder"]');
    if (!(defaultSlot instanceof HTMLSlotElement) || !(overflowSlot instanceof HTMLSlotElement) || !(moreSlot instanceof HTMLSlotElement) || !(overflow instanceof HTMLElement) || !(list instanceof HTMLUListElement) || !(placeholder instanceof HTMLLIElement)) {
      throw new Error('Invalid element types in <OverflowList />');
    }
    this.refs = { defaultSlot, overflowSlot, moreSlot, overflow, list, placeholder };
  }

  handleChange(entries) {
    let width = null;
    let height = null;

    for (const entry of entries) {
      if (entry instanceof ResizeObserverEntry) {
        width = Math.round(entry.contentRect.width);
        height = Math.round(entry.contentRect.height);
      }
    }
    // Skip reflow if dimensions are 0 or the same as the last reflow
    const changed = width !== this.lastDimensions.width || height !== this.lastDimensions.height;
    if (changed) {
      this.lastDimensions = { width, height };
      this.requestReflow();
    }
  }

  requestReflow(lastVisibleElement = null) {
    if (this._reflowFrameId !== null) cancelAnimationFrame(this._reflowFrameId);
    this._reflowFrameId = requestAnimationFrame(() => {
      this._reflowFrameId = null;
      this.reflowItems(lastVisibleElement);
    });
  }

  moveItemsToDefaultSlot() {
    const { defaultSlot, overflowSlot } = this.refs;
    for (const element of overflowSlot.assignedElements()) {
      element.slot = defaultSlot.name;
    }
  }

  reset() {
    const { list } = this.refs;
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    this.moveItemsToDefaultSlot();
    list.style.removeProperty('height');
    this.style.setProperty('--overflow-count', '0');
  }

  updateMinimumReached(visibleElements) {
    if (this.minimumItems !== null) {
      const minimumReached = visibleElements.length < this.minimumItems;
      this.toggleAttribute('minimum-reached', minimumReached);
      this.dispatchEvent(new CustomEvent('overflow-minimum', {
        detail: { minimumReached },
        bubbles: true
      }));
    }
  }

  showAll() {
    const { placeholder } = this.refs;
    placeholder.style.setProperty('width', '0');
    placeholder.style.setProperty('display', 'none');
    this.setAttribute('disabled', 'true');
  }

  reflowItems(lastVisibleElement = null) {
    const { defaultSlot, overflowSlot, moreSlot, list, placeholder } = this.refs;
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    // Avoid layout shifts while reflowing the list
    const { height } = this.firstElementChild?.getBoundingClientRect() ?? {};
    if (height) list.style.height = `${height}px`;
    list.style.setProperty('overflow', 'hidden');
    // Move all elements to the default slot so we can check which ones overflow
    this.moveItemsToDefaultSlot();
    const elements = defaultSlot.assignedElements();
    moreSlot.hidden = true;
    placeholder.hidden = true;
    const listRect = list.getBoundingClientRect();
    // Store the initial dimensions for comparison later
    this.lastDimensions = { width: Math.round(listRect.width), height: Math.round(listRect.height) };
    const getVisibleElements = () => {
      return elements.filter(element => {
        const rect = element.getBoundingClientRect();
        return rect.top <= listRect.top + 1
      });
    };
    let visibleElements = getVisibleElements();
    // If not all items fit or we have a lastVisibleElement, let's calculate with "More" button
    if (visibleElements.length < elements.length || lastVisibleElement) {
      // Putting the "More" item (and lastVisibleElement, if provided) at the start of the list lets us see which items will fit on the same row
      moreSlot.style.setProperty('order', '-1');
      moreSlot.hidden = false;
      moreSlot.style.setProperty('height', `${height}px`);
      if (lastVisibleElement) lastVisibleElement.style.setProperty('order', '-1');
      // Recalculate the visible elements
      visibleElements = getVisibleElements();
      // Reset the order
      moreSlot.style.removeProperty('order');
      if (lastVisibleElement) lastVisibleElement.style.removeProperty('order');
      // If we have a lastVisibleElement, ensure it's in the last visible position
      if (lastVisibleElement && visibleElements.includes(lastVisibleElement)) {
        visibleElements = visibleElements.filter(element => element !== lastVisibleElement);
        visibleElements.push(lastVisibleElement);
      }
      moreSlot.style.setProperty('height', 'auto');
    }

    const overflowingElements = elements.filter(element => !visibleElements.includes(element));
    const [firstOverflowingElement] = overflowingElements;
    const hasOverflow = overflowingElements.length > 0;
    const placeholderWidth = firstOverflowingElement ? firstOverflowingElement.clientWidth : 0;
    // Move the elements to the correct slot
    for (const element of elements) {
      element.slot = overflowingElements.includes(element) ? overflowSlot.name : defaultSlot.name;
    }
    // If there are overflowing elements
    // Show more button and placeholder if needed
    moreSlot.hidden = !hasOverflow;
    if (hasOverflow) {
      // Set the width and height of the placeholder so the list can grow if there is space
      placeholder.style.width = `${placeholderWidth}px`;
      placeholder.hidden = false;
    }

    list.style.setProperty('counter-reset', `overflow-count ${overflowingElements.length}`);
    this.style.setProperty('--overflow-count', `${overflowingElements.length}`);
    list.style.removeProperty('overflow');
    // Check if the minimum-reached state should be updated
    hasOverflow && this.updateMinimumReached(visibleElements);
    // Observe the list for changes in size
    this.resizeObserver.observe(this);
    this.mutationObserver.observe(this, { childList: true });
  }
}

customElements.define('overflow-list', OverflowList);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', this.expandShowMore.bind(this));
  }

  expandShowMore(event) {
    const button = event.currentTarget;
    const parent = button.closest('.parent-wrap');
    button.classList.toggle('show');
    button.querySelector('span').innerText = button.classList.contains('show') ? button.dataset.showLessText : button.dataset.showMoreText;
    parent.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);

class StickyElement extends HTMLElement {
  constructor() {
    super();
    this.currentPosition = window.scrollY;
    this.screenHeight = window.innerHeight;
    this.stickyElementHeight = this.offsetHeight;
    this.bottomGap = 20;
    this.topGap = 30;
    this._ticking = false;
    window.addEventListener('scroll',
      this.onScrollHandler.bind(this), {
      capture: true,
      passive: true
    }
    );
  }

  get headerSticky() {
    return document.querySelector('sticky-header')
  }

  get headerStickyHeight() {
    const header = this.headerSticky;
    return header ? Math.round(header.clientHeight) + 20 : 20
  }

  get headerStickyType() {
    const header = this.headerSticky;
    return header ? this.headerSticky.dataset.stickyType : null
  }

  onScrollHandler() {
    if (this._ticking) return;
    this._ticking = true;
    requestAnimationFrame(() => {
      this.screenHeight = window.innerHeight;
      this.stickyElementHeight = this.offsetHeight;
      this.updateStickyPosition();
      this._ticking = false;
    });
  }

  updateStickyPosition() {
    const prevPosition = this.currentPosition;
    this.currentPosition = window.scrollY;
    const direction = this.currentPosition < prevPosition ? 'up' : 'down';
    const stickyType = this.headerStickyType;
    const headerHeight = stickyType === 'on-scroll-up' && direction !== 'up' ? 0 : this.headerStickyHeight;
    const style = window.getComputedStyle(this);
    const stickyElementTop = parseInt(style.insetBlockStart.replace('px', ''), 10) || 0;
    const endScroll = this.screenHeight - this.stickyElementHeight - this.bottomGap;
    if (this.stickyElementHeight + headerHeight + this.topGap + this.bottomGap > this.screenHeight) {
      if (direction === 'up') {
        if (stickyElementTop < headerHeight + this.topGap) {
          const newTop = stickyElementTop + (prevPosition - this.currentPosition);
          this.setStickyPosition(newTop);
        } else {
          this.setStickyPosition(headerHeight + this.topGap);
        }
      } else {
        if (stickyElementTop > endScroll) {
          const newTop = stickyElementTop - (this.currentPosition - prevPosition);
          this.setStickyPosition(newTop);
        } else {
          this.setStickyPosition(endScroll);
        }
      }
    } else {
      this.setStickyPosition(headerHeight + this.topGap);
    }
  }

  setStickyPosition(value) {
    this.style.insetBlockStart = `${value}px`;
    this.style.setProperty('--inset', `${value}px`);
  }
}
customElements.define('sticky-element', StickyElement);

class VideoMedia extends DeferredMedia {
  constructor() {
    super();
  }

  playerTarget() {
    if (this.hasAttribute('host')) {
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1024px)').matches;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        if (this.getAttribute('host') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }
          await onYouTubePromise;
          const player = new YT.Player(this.querySelector('iframe'), {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                  this.setAttribute('muted', '');
                }
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                  if (event.data === YT.PlayerState.ENDED) {
                    this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
                  }
                }
                if (player.isMuted()) {
                  this.setAttribute('muted', '');
                } else {
                  this.removeAttribute('muted');
                }
              }
            }
          });
        }
        if (this.getAttribute('host') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }
          const player = new Vimeo.Player(this.querySelector('iframe'));
          if (muteVideo) {
            player.setMuted(true);
            this.setAttribute('muted', '');
          }
          player.on('play', () => this.setAttribute('playing', ''));
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => {
            this.removeAttribute('playing');
            this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
          });
          player.on('volumechange', () => {
            if (player.muted) {
              this.setAttribute('muted', '');
            } else {
              this.removeAttribute('muted');
            }
          });
          resolve(player);
        }
      });
    } else {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      const player = this.querySelector('video');
      if (player.muted) this.setAttribute('muted', '');
      // Apply necessary attributes for Mobile Safari
      player.setAttribute('playsinline', ''); // required for mobile inline playback
      player.setAttribute('preload', 'auto'); // help preload
      // Preload immediately
      player.load();
      // Force autoplay for Safari/iOS
      if (player.muted && player.autoplay) {
        const tryPlay = player.play();
        if (tryPlay && typeof tryPlay.catch === 'function') {
          tryPlay.catch(() => {
            this.setAttribute('suspended', '');
            // player.controls = true;
          });
        }
      }
      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) this.removeAttribute('playing');
      });
      player.addEventListener('volumechange', () => {
        if (player.muted) {
          this.setAttribute('muted', '');
        } else {
          this.removeAttribute('muted');
        }
      });
      const handleEnd = () => {
        this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
      };
      const setupLoopDetection = () => {
        const onTimeUpdate = () => {
          const duration = player.duration;
          if (!isNaN(duration) && player.currentTime >= duration - 0.3) {
            player.removeEventListener('timeupdate', onTimeUpdate);
            handleEnd();
          }
        };
        player.addEventListener('timeupdate', onTimeUpdate);
      };

      if (player.loop) {
        if (isNaN(player.duration)) {
          player.addEventListener('loadedmetadata', setupLoopDetection, { once: true });
        } else {
          setupLoopDetection();
        }
      } else {
        player.addEventListener('ended', handleEnd);
      }
      return player;
    }
  }

  playerHandler(target, prop) {
    if (this.getAttribute('host') === 'youtube') {
      prop === 'play' ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === 'play' && !this.hasAttribute('host')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
          }
        });
      } else if (prop === 'muted' && !this.hasAttribute('host')) {
        target.muted = true;
      } else if (prop === 'unmuted' && !this.hasAttribute('host')) {
        target.muted = false;
      } else {
        target[prop]();
      }
    }
  }
}

customElements.define('video-media', VideoMedia);

window.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.st-popup ')) return
  // document.querySelector('.st-popup h3').innerHTML = 'Wishlist Popup';
  document.querySelector('.st-popup .st-cancel-button')?.setAttribute('aria-label', 'Cancel');
  document.querySelector('.st-popup .st-confirm-button')?.setAttribute('aria-label', 'Confirm');
});

if (Shopify.designMode) {
  document.addEventListener('shopify:block:select', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:block:deselect', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:load', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:reorder', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:select', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:deselect', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:inspector:activate', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:inspector:deactivate', () => {
    closeSideDrawer();
    hideModalDialog();
  });
}

class CardHoverPopup extends HTMLElement {
  constructor() {
    super();
    this._card = this.closest('.card');

    if (!this._card) return;

    this._bindEvents();
  }

  _bindEvents() {
    this._card.addEventListener('mouseenter', this._handleMouseEnter);
    this._card.addEventListener('mouseleave', this._handleMouseLeave);
  }

  _handleMouseEnter = () => {
    this.querySelectorAll('product-swatches').forEach((swatches) => {
      if (typeof swatches.mount === 'function') {
        swatches.mount();
      }
    });
    this.classList.add('active');
  }

  _handleMouseLeave = () => {
    this.classList.remove('active');
  }
}

customElements.define('card-hover-popup', CardHoverPopup);

const ELFSIGHT_LAZY_SELECTOR = '[data-elfsight-lazy]';
const ELFSIGHT_SCRIPT_SELECTOR = 'script[src*="elfsight.com/platform"], script[src*="elfsightcdn.com/platform.js"]';
const ELFSIGHT_DEFAULT_SCRIPT_SRC = 'https://static.elfsight.com/platform/platform.js';
let elfsightScriptPromise;

function mountElfsightWidget(element) {
  if (!element || element.dataset.elfsightMounted === 'true') return;

  const template = element.querySelector('template');

  if (template) {
    element.appendChild(template.content.cloneNode(true));
  }

  element.dataset.elfsightMounted = 'true';
}

function loadElfsightScript(scriptSrc) {
  const existingScript = document.querySelector(ELFSIGHT_SCRIPT_SELECTOR);

  if (existingScript) {
    if (existingScript.dataset.elfsightLazyReady === 'true') {
      return Promise.resolve(existingScript);
    }

    if (!elfsightScriptPromise) {
      elfsightScriptPromise = new Promise((resolve, reject) => {
        existingScript.addEventListener('load', () => {
          existingScript.dataset.elfsightLazyReady = 'true';
          resolve(existingScript);
        }, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
      });
    }

    return elfsightScriptPromise;
  }

  if (!elfsightScriptPromise) {
    elfsightScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = scriptSrc || ELFSIGHT_DEFAULT_SCRIPT_SRC;
      script.defer = true;
      script.dataset.useServiceCore = 'true';
      script.addEventListener('load', () => {
        script.dataset.elfsightLazyReady = 'true';
        resolve(script);
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  return elfsightScriptPromise;
}

function initElfsightLazyWidget(element) {
  if (!element || element.dataset.elfsightInitialized === 'true') return;

  const activateWidget = () => {
    if (element.dataset.elfsightLoaded === 'true') return;

    mountElfsightWidget(element);
    element.dataset.elfsightLoaded = 'true';
    loadElfsightScript(element.dataset.elfsightScriptSrc).catch(() => {
      element.dataset.elfsightLoaded = 'false';
    });
  };

  const threshold = Number(element.dataset.elfsightThreshold || 800);
  const isEditorMode = element.dataset.elfsightEditorMode === 'true' || Shopify.designMode;

  if (isEditorMode) {
    activateWidget();
  } else if ('IntersectionObserver' in window) {
    createObserver({
      element,
      threshold,
      callback: activateWidget,
    });
  } else {
    activateWidget();
  }

  element.dataset.elfsightInitialized = 'true';
}

function initElfsightLazyWidgets(container = document) {
  container.querySelectorAll(ELFSIGHT_LAZY_SELECTOR).forEach(initElfsightLazyWidget);
}

document.addEventListener('DOMContentLoaded', () => {
  initElfsightLazyWidgets();
});

document.addEventListener('shopify:section:load', (event) => {
  initElfsightLazyWidgets(event.target);
});
